'use strict';

;( () => {
	if ( ! /iP(hone|ad|od)/.test( navigator.userAgent ) ) {
		document.documentElement.classList.add( 'no-overscroll' );
	}
})();
